import { Option } from 'common/components/DetailControls';

export const yesNoOptions: Option[] = [
  { id: 1, label: 'No' },
  { id: 2, label: 'Yes' },
];

export const [noOption, yesOption] = yesNoOptions;
